import { ITEM_TYPE } from './itemType'

const item = {
  amount: 0,
  date: undefined,
  description: '',
  category: undefined,
  type: ITEM_TYPE.EXPENSE
}

export function create(data = {}) {
  const { amount, date, description, category, type } = data

  return {
    ...item,
    amount: amount === null || amount === undefined ? 0 : amount,
    date,
    description: description || '',
    category,
    type: type === null || type === undefined ? ITEM_TYPE.EXPENSE : type
  }
}
